import { createFileRoute, redirect } from '@tanstack/react-router'
import { USERS_PAGE_READ, USERS_TABS } from '~/components/routes/users/tabs'
import { withRoutePermissions } from '~/utils/rbac'
import { firstAuthorizedScreen } from '~/utils/rbacModuleIndex'

export const Route = createFileRoute('/_authenticated/users/')({
  staticData: {
    permission: USERS_PAGE_READ,
  },
  beforeLoad: ({ context }) => {
    const first = firstAuthorizedScreen(context.ability, USERS_TABS)
    // Les deux onglets du module sont couverts par `USERS_PAGE_READ` : le repli ne sert qu'à
    // satisfaire le typage. La création d'un compte BO est passée sous Administration.
    throw redirect({ to: first?.to ?? '/users/app' })
  },
})
withRoutePermissions(Route)
